import { Alert, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useSession } from "../../../api/useSession";
import PageContainer from "../../../components/PageContainer/PageContainer";
import SkillsterTitle from "../../../components/SkillsterTitle/SkillsterTitle";
import ActiveApiKeysList from "../../../features/Integrations/ApiKeysList/ActiveApiKeysList";
import InactiveApiKeysList from "../../../features/Integrations/ApiKeysList/InactiveApiKeysList";
import SubBar from "../../../features/Layout/SubBar/SubBar";
import { useIsAdminUser } from "../../../helpers/server.helpers";

export const Route = createFileRoute("/(app)/settings/integrations")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data: session, isSuccess } = useSession();
  const isAdmin = useIsAdminUser();

  return (
    <>
      <SubBar title="Integrationer" />
      <PageContainer pos="relative">
        <Stack gap="xl">
          {isSuccess &&
            !session.User.ViewConfig.IntegrationsEnabled &&
            isAdmin && (
              <Alert icon={<IconInfoCircle />}>
                <Stack gap="xs">
                  <Text fw="bold">Skolan har inte integrationer aktiverat</Text>
                </Stack>
                <Text c="bluegray.5">
                  I egenskap av admin har du möjlighet att se denna sida ändå
                  för att kunna redigera och ta bort nycklar utan att behöva
                  aktivera integrationer för skolan.
                </Text>
              </Alert>
            )}
          <Stack>
            <SkillsterTitle order={4}>API-nycklar</SkillsterTitle>
            <Text maw={500} c="bluegray">
              Här kan du skapa API-nycklar som behövs för att ge externa system
              tillgång till viss data från Skillster. Nycklarna visas en gång
              vid skapandet, och går ej att se igen därefter. Dessa nycklar ska
              sparas på ett säkert sätt och får ej delas med någon obehörig.
            </Text>
          </Stack>

          <ActiveApiKeysList />
          <InactiveApiKeysList />
        </Stack>
      </PageContainer>
    </>
  );
}
